 import React, { useEffect, useState} from 'react';
//import UserContext from '../context/UserContext';
import { api } from '../utils/apiHelper';
import AdSectBeatBattle from './AdSectBeatBattle';
import MemItems from './MemItems';
import BidOffer from './BidOffer';
import PopCustoms from './PopCustom';
import AdminFarmers from './AdminFarmers';
import '../styles/TheAdministrator.css';

const TheAdministrator = () => {
  //const { authUser } = useContext(UserContext);
  const [data, setData] = useState({
    totalUsers: 0,
    totalProjects: 0,
    totalFiles: 0,
    totalRevenue: 0,
  });
  const [allUsers, setAllUsers] = useState([]);
  const [selectedPopCustomId, setSelectedPopCustomId] = useState(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await api('/admin-dashboard-summary', 'GET');
        if (response && response.success) {
          setData({
            totalUsers: response.totalUsers,
            totalProjects: response.totalProjects,
            totalFiles: response.totalFiles,
            totalRevenue: response.totalRevenue,
          });
        }
      } catch (error) {
        console.error('Error fetching admin summary:', error);
      }
    };

    const fetchAllUsers = async () => {
      try {
        const res = await api('/get-all-video-hero-users', 'GET');
        if (Array.isArray(res)) {
          setAllUsers(res);
        }
      } catch (err) {
        console.error('Error fetching users:', err);
      }
    };

    fetchAdminData();
    fetchAllUsers();
  }, []);

  const handleSetActivePopCustom = async () => {
    if (!selectedPopCustomId) {
      alert('Please select a PopCustom first.');
      return;
    }

    try {
      await api('/set-active-popcustom', 'POST', { popCustomId: selectedPopCustomId });
      alert('Active popup set successfully');
    } catch (err) {
      console.error('Error setting active popup:', err);
      alert('Failed to set active popup');
    }
  };

  const handleDeletePopCustom = async (popCustomId, imageKey) => {
    if (!window.confirm('Are you sure you want to delete this PopCustom?')) return;
    try {
      await api('/delete-popcustom', 'POST', { popCustomId, imageKey });
      alert('PopCustom deleted successfully');
      const res = await api('/get-all-video-hero-users', 'GET');
      if (Array.isArray(res)) {
        setAllUsers(res);
      }
    } catch (err) {
      console.error('Error deleting PopCustom:', err);
      alert('Failed to delete PopCustom');
    }
  };


      return (
    <div className="admin-container">
    <h2>The Administrator Dashboard</h2>

      <div className="admin-stats">
        <div className="stat-card"><h3>Total Users</h3><p>{data.totalUsers}</p></div>
        <div className="stat-card"><h3>Total Projects</h3><p>{data.totalProjects}</p></div>
        <div className="stat-card"><h3>Total Files</h3><p>{data.totalFiles}</p></div>
        <div className="stat-card"><h3>Total Revenue</h3><p>${data.totalRevenue.toFixed(2)}</p></div>
      </div>

      <div className="admin-users-section">
        <h3>All Registered Users</h3>
        <table className="admin-user-table">
          <thead>
            <tr><th>Name</th><th>Username</th><th>Email</th><th>Verified</th></tr>
          </thead>
          <tbody>
            {allUsers.map((user) => (
              <tr key={user._id}>
                <td>{user.name}</td>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>{user.verified ? 'Yes' : 'No'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      < AdminFarmers />

      <div className="admin-submissions-section">
        <h3>PopCustoms</h3>
        {allUsers
          .filter(user => user.email === 'support@editfarmer.com')
          .map(user => (
            <div key={user._id} className="user-submissions">
              <h4>{user.name} ({user.username})</h4>
              < PopCustoms />

              {user.popCustoms && user.popCustoms.length > 0 && (
                <div>
                  <h5>PopCustoms (Select to Activate)</h5>
                  <ul>
                    {user.popCustoms.map((pop) => (
                      <li
                        key={pop._id}
                        style={{
                          cursor: 'pointer',
                          backgroundColor: selectedPopCustomId === pop._id ? '#e0f7fa' : 'transparent'
                        }}
                        onClick={() => setSelectedPopCustomId(pop._id)}
                      >
                        <strong>{pop.header}</strong> – {pop.buttonLabel}<br />
                        <em>{pop.paragraph?.text}</em>
                        {selectedPopCustomId === pop._id && <span> (Selected)</span>}
                        <br />
                        <button onClick={(e) => {
                          e.stopPropagation();
                          handleDeletePopCustom(pop._id, pop.imageKey);
                        }}>
                          Delete
                        </button>
                      </li>
                    ))}
                  </ul>
                  <button onClick={handleSetActivePopCustom}>Set as Active Popup</button>
                </div>
              )}
            </div>
          ))}
      </div>

      < AdSectBeatBattle />
     
      <div className="auction-card">
       <h1 className="auction">
      Auction Depo
      </h1>
      < MemItems />
      < BidOffer />
      </div>
    </div>
  );
};

export default TheAdministrator;